(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-events-nav"]) return;
  try {
    
(function() {
  var nav = document.querySelector('.gt-enav');
  if (!nav) return;

  /* ── Move the nav INSIDE sticky-header so it sticks automatically ── */
  function moveIntoStickyHeader() {
    var stickyHeader =
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper');
    if (stickyHeader && !stickyHeader.contains(nav)) {
      stickyHeader.appendChild(nav);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveIntoStickyHeader);
  } else {
    moveIntoStickyHeader();
  }
  /* Retry after theme JS runs */
  setTimeout(moveIntoStickyHeader, 200);

  /* ── Dropdown toggle ── */
  var items = document.querySelectorAll('.gt-enav__item--has-dropdown');
  items.forEach(function(item) {
    var btn = item.querySelector('.gt-enav__trigger');
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = item.classList.contains('gt-enav__item--open');
      items.forEach(function(i) { i.classList.remove('gt-enav__item--open'); i.querySelector('.gt-enav__trigger').setAttribute('aria-expanded','false'); });
      if (!isOpen) {
        item.classList.add('gt-enav__item--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', function() {
    items.forEach(function(i) { i.classList.remove('gt-enav__item--open'); i.querySelector('.gt-enav__trigger').setAttribute('aria-expanded','false'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticket-selection"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.getElementById('gt-ticket-selection');
  if (!section) return;

  /* ── Quantity buttons ── */
  section.querySelectorAll('.gt-ts__qty-wrap').forEach(function(wrap) {
    var input  = wrap.querySelector('.gt-ts__qty-input');
    var minus  = wrap.querySelector('.gt-ts__qty-minus');
    var plus   = wrap.querySelector('.gt-ts__qty-plus');
    minus.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    plus.addEventListener('click', function() {
      var v = parseInt(input.value, 10);
      var max = parseInt(input.getAttribute('max'), 10) || 10;
      if (v < max) input.value = v + 1;
    });
  });

  /* ── Toast helper ── */
  var toast = document.getElementById('gt-ts-toast');
  var toastTimer;
  function showToast() {
    clearTimeout(toastTimer);
    toast.classList.add('gt-ts__toast--show');
    toastTimer = setTimeout(function() {
      toast.classList.remove('gt-ts__toast--show');
    }, 3500);
  }

  /* ── Buy Now — attach quantity ── */
  section.querySelectorAll('.gt-ts__btn--buy').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var card = btn.closest('.gt-ts__card');
      var qty  = card.querySelector('.gt-ts__qty-input').value || 1;
      var vid  = btn.getAttribute('data-variant-id');
      window.location.href = '/cart/' + vid + ':' + qty;
    });
  });

  /* ── Add to Cart — AJAX ── */
  section.querySelectorAll('.gt-ts__btn--cart').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var card = btn.closest('.gt-ts__card');
      var qty  = parseInt(card.querySelector('.gt-ts__qty-input').value, 10) || 1;
      var vid  = parseInt(btn.getAttribute('data-variant-id'), 10);

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: vid, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        btn.textContent = 'Added ✓';
        showToast();
        /* Trigger Fabric theme cart drawer if available */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function() {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
